import { gql } from "@apollo/client";
import { policyData } from "./fragments";

export const POLICY_DATA_QUERY = gql`
  query policyData($documentId: Int!) {
    policyData(documentId: $documentId) {
      ...policyData
    }
  }
  ${policyData}
`;

export const PAYMENT_TYPES_QUERY = gql`
  query paymentTypes {
    paymentTypes {
      id
      name
    }
  }
`;

export const ACTIVITY_TYPE_QUERY = gql`
  query activityType($id: Int!) {
    activityType(id: $id) {
      id
      code
      name
    }
  }
`;

export const USAGE_TYPE_QUERY = gql`
  query usageType($id: Int!) {
    usageType(id: $id) {
      id
      code
      name
    }
  }
`;

export const CITY_QUERY = gql`
  query city($cityId: Int!) {
    city(cityId: $cityId) {
      id
      name
    }
  }
`;
